import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconVSCode({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="m12.14.098 3.294 1.585a1 1 0 0 1 .566.9v10.741a1 1 0 0 1-.566.901L12.14 15.81a.997.997 0 0 1-1.059-.123l-.07-.064.056.05a.586.586 0 0 0 .935-.47V.706a.586.586 0 0 0-.935-.47l-.057.048.071-.062A.997.997 0 0 1 12.14.098zM10.5.692a.5.5 0 0 1 .836.369v3.607l-4.19 3.32 4.19 3.251v3.603a.5.5 0 0 1-.837.368L.217 5.782a.666.666 0 0 1 .001-.985l.881-.801a.666.666 0 0 1 .851-.038l2.716 2.107L10.5.692zM2.293 8.336l2.047 1.866-2.39 1.748a.666.666 0 0 1-.85-.038l-.882-.801a.666.666 0 0 1 0-.985l2.075-1.79z"/>
        </svg>
    );
}

export default IconVSCode;
